













































import { Vue, Component, Watch } from "vue-property-decorator";
import { fetch, getCookie } from "@szgc/plt-core-v2";
@Component({
  name: "Ctip",
  components: {}
})
export default class Ctip extends Vue {
  private tipList: any[] = [];

  private visible: boolean = false;

  private tip: string = "";

  private prefix: any = "";

  async addCommonTip() {
    if (!this.tip || this.tip === "") return;
    this.prefix = getCookie("plt-api-route") || "";
    try {
      const { success, message } = await fetch.post(this.prefix + "/api/appproc/phrases", {
        data: {
          phrase: this.tip,
          phraseType: 1
        }
      });
      if (success) {
        this.getCommonTipList();
        this.tip = "";
      } else {
        this.$message.error("添加常用语失败");
        console.log(message);
      }
    } catch (error) {
      this.$message.error("添加常用语失败");
      console.log(error);
    }
  }

  onTipClick(tip: any) {
    this.$emit("selected", tip.phrase);
    this.visible = false;
  }

  @Watch("visible")
  onCtipClose(newValue: boolean) {
    if (newValue === false) {
      this.tip = "";
    }
  }

  async onTipClose(tip: any, index: number) {
    try {
      const { success } = await fetch.delete(this.prefix + "/api/appproc/phrases/" + tip.phraseId);
      if (success) {
        // this.getCommonTipList();
        this.$delete(this.tipList, index);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getCommonTipList() {
    try {
      const { success, data } = await fetch.get(this.prefix + "/api/appproc/phrases");
      if (success) {
        this.tipList = data.sort((d: any) => (d.phraseType === 0 ? -1 : 1));
      }
    } catch (error) {
      console.log(error);
    }
  }

  mounted() {
    this.getCommonTipList();
  }
}
